"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rules_1 = require("./rules");
const term_1 = require("./interpriterRules/term");
const factor_1 = require("./interpriterRules/factor");
const expression_1 = require("./interpriterRules/expression");
const relationExpression_1 = require("./interpriterRules/relationExpression");
const pipeExpression_1 = require("./interpriterRules/pipeExpression");
const assignment_1 = require("./interpriterRules/assignment");
const program_1 = require("./interpriterRules/program");
const blockStatement_1 = require("./interpriterRules/blockStatement");
const returnStatement_1 = require("./interpriterRules/returnStatement");
const functions_1 = require("./interpriterRules/functions");
const ifStatement_1 = require("./interpriterRules/ifStatement");
const pipeFrom_1 = require("./interpriterRules/pipeFrom");
const pipeArguments_1 = require("./interpriterRules/pipeArguments");
const logicExpression_1 = require("./interpriterRules/logicExpression");
const rangeExpression_1 = require("./interpriterRules/rangeExpression");
exports.interpreter = ({ ast, execObject, }) => {
    let value = null;
    switch (ast.name) {
        case rules_1.Rules.ProgramRoot:
            value = program_1.program({ ast, execObject });
            break;
        case rules_1.Rules.Assignment:
            value = assignment_1.assignment({ ast, execObject });
            break;
        case rules_1.Rules.IfStatement:
            value = ifStatement_1.ifStatement({ ast, execObject });
            break;
        case rules_1.Rules.PipeExpression:
            value = pipeExpression_1.pipeExpression({ ast, execObject });
            break;
        case rules_1.Rules.PipeFrom:
            value = pipeFrom_1.pipeFrom({ ast, execObject });
            break;
        case rules_1.Rules.PipeArguments:
            value = pipeArguments_1.pipeArguments({ ast, execObject });
            break;
        case rules_1.Rules.LogicExpression:
            value = logicExpression_1.logicExpression({ ast, execObject });
            break;
        case rules_1.Rules.RelationExpression:
            value = relationExpression_1.relationExpression({ ast, execObject });
            break;
        case rules_1.Rules.Expression:
            value = expression_1.expression({ ast, execObject });
            break;
        case rules_1.Rules.Term:
            value = term_1.term({ ast, execObject });
            break;
        case rules_1.Rules.RangeExpression:
            value = rangeExpression_1.rangeExpression({ ast, execObject });
            break;
        case rules_1.Rules.Factor:
            value = factor_1.factor({ ast, execObject });
            break;
        case rules_1.Rules.FunctionStatement:
            value = functions_1.functionStatement({ ast, execObject });
            break;
        case rules_1.Rules.BlockStatement:
            value = blockStatement_1.blockStatement({ ast, execObject });
            break;
        case rules_1.Rules.ReturnStatement:
            value = returnStatement_1.returnStatement({ ast, execObject });
            break;
    }
    if (execObject.manager.variable.returnExist) {
        return execObject.manager.variable.returnValue;
    }
    else {
        return value;
    }
};
